
/* injects from baggage-loader */

'use strict';

export default class DialogIntroController {
    constructor($log, $state, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
    }    

    $onInit(){
        let $ctrl = this;
        this.loaded = false;
        this.bg = this.resolve.bg;
        if(this.resolve.dialog!==false){
            this.hasDialog = true;
            this.dialog = this.resolve.dialog;
            this.direction = this.resolve.direction;
        } else {
            this.time = this.$timeout(() => $ctrl.ok(), 2000)
        }
        this.$timeout(() => $ctrl.show(), 800)
    }

    show(){
        this.loaded = true;
    }

    ok(){
        this.modalInstance.close(true);
    }

    cancel(){
        this.modalInstance.dismiss('cancel');
    }

    passIntroBg(){
        this.ok();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/intro/intro.controller.js